import svgArr from "@/components/common/socialMediaSvg";
import selectColorSocialMedia from "@/components/common/selectColorSocialMedia";
import { SITE_DOMAIN } from "@/constant";

export const SocialMediaColors = [
  {
    color: "#2E576F",
  },
  {
    color: "#A42114",
  },
  {
    color: "#DB7139",
  },
  {
    color: "#7966D2",
  },
  {
    color: "#133276",
  },
  {
    color: "#A3274E",
  },
];

export const SocialInitialItems = [
  {
    id: 0,
    icon: "/social-items/website.svg",
    type: "website",
    placeholderText: "Check our website",
    text: "",
    value: "",
  },
  {
    id: 1,
    icon: "/social-items/youtube.svg",
    type: "youtube",
    placeholderText: "Subscribe our channel",
    text: "",
    value: "",
  },
  {
    id: 2,
    icon: "/social-items/instagram.svg",
    type: "instagram",
    placeholderText: "Follow us",
    text: "",
    value: "",
  },
];

export const SocialMediaInitialData = {
  payload: {
    name: "",
    sharing: "1",
    design_colors_primary: selectColorSocialMedia[0].color,
    design_colors_button: selectColorSocialMedia[0].buttonColor,
    template: "",
    template_path: "",
    template_name: "",
    template_type: "",
    upload_svg: {
      key: "one",
      icon: svgArr[0].icon,
    },
    headline: "",
    about_us: "",
    welcome_screen: "",
    welcome_path: "",
    svgColor: "#2E576F",
    showUploadOwn: false,
    socialItems: SocialInitialItems,
  },
};
